import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { FrontendErrorService } from '@services/frontend-error/frontend-error.service';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '@services/profiles/profile.service';

@Component({
    selector: 'app-frontend-errorlog-detail',
    templateUrl: './frontend-errorlog-detail.component.html',
    styleUrls: ['./frontend-errorlog-detail.component.scss'],
    providers: [FrontendErrorService, ProfileService],
    standalone: false
})
export class FrontendErrorlogDetailComponent implements OnInit {

  isLoading: boolean;
  stackIsArray: boolean;

  title = 'Error: ';

  errorLog: Models.FrontendError;
  profile: Models.Profile;

  constructor(
    private frontendErrorService: FrontendErrorService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.frontendErrorService.get(this.route.snapshot.params['id']).then(error => {
      this.title += error.frontendType;
      this.errorLog = error;
      this.stackIsArray = this.errorLog.errorStack instanceof Array;
      if (this.errorLog.userId) {
        this.profileService.get(this.errorLog.userId).then(profile => {
          this.profile = profile;
        })
      }
      this.isLoading = false;
    });
  }

}
